import { http } from "../http";
import { Params } from "@/facilities/model/user";
const BASEURL = "/api/oms-schedule";

export const creatOmsSchedule = async (params: Params) => {
  return await http.post(BASEURL, params);
};

export const updateOmsSchedule = async (params: Params) => {
  return await http.put(BASEURL, params);
};

export const getOmsDetail = async (id?: string) => {
  return await http.get(`${BASEURL}/realtime/${id}`);
};

export const getOmsList = async (params?: Params) => {
  return await http.get(`${BASEURL}/page`, { params });
};

export const postSwitchOn = async (id?: string) => {
  return await http.post(`${BASEURL}/switch-on/${id}`);
};

export const getCount = async () => {
  return await http.get(`${BASEURL}/count`);
};
